import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcMarketingIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';

import { MetaBlock } from '../MetaBlock/MetaBlock';

interface IProfilePositionProps {
  className?: string;
  position: string;
}

export const ProfilePosition: FC<IProfilePositionProps> = observer(({ className, position }) => {
  const { t } = useTranslation();

  return (
    <MetaBlock
      className={className}
      label={t('user_position')}
      Icon={IcMarketingIcon}
    >
      {position}
    </MetaBlock>
  );
});
